export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8735.d6eb4211.jpg";